// extracted by mini-css-extract-plugin
export default {"item":"Item_item__RAbrc","item_trap":"Item_item_trap__PeljK","item_food":"Item_item_food__A4Rek"};